import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useServices } from 'hooks/useServices';
import { useIsMobile } from 'hooks/useIsMobile';
import SlidersEmarsys from 'components/Emarsys/SlidersEmarsys/index_product';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { useHomePage } from 'hooks/useHomePage';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { useForm } from 'react-hook-form';
import getTelmexStatus from 'services/getTelmexStatus';
import { ModalError } from 'components/Error/ErrorModal';
import { decodeStorage } from 'functions/storageBase64';
import { postClaroScore } from 'services/claroScore';
import getShipping from 'services/getShipping';
import { ClasicSelectTypeNew } from 'components/Forms/Select';
import { ProgressBar } from 'components/ProgressBar';
import { useStorage64 } from 'hooks/useStorageBase64';


export function IngresoMensuelIncode() {

    const history = useHistory();
    const { isMobile } = useIsMobile();
    const infoLineaTelmexStorage = decodeStorage('infoLineaTelmexStorage');
    const [lineaTelmex, setLineaTelmex] = useState(infoLineaTelmexStorage?.LineaTelmex);
    const [, setInfoIngmensualStorage] = useStorage64('infoIngmensualStorage', '');

    //respuestas servicios
    const [postEnviarClaroScoreRes, setPostEnviarClaroScoreRes] = useState(false);
    const [getTelmexStatusRes, setGetTelmexStatusRes] = useState(false);

    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);

    const EXTERNO = decodeStorage('EXTERNO')

    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'verificar') {
            window.location.href = `${BASE_PATH}`;
        }
    }


    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.scrollTo(0, 0);
        window.ineum('page', 'Telmex  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
    }, [])

    const datosPersonalesStorage = decodeStorage("infoPersonalStorageIncode")
    const [datosPersonales, setDatosPersonales] = useState(datosPersonalesStorage);

    const [shipping, setShupping] = useState({});
    const [inputCalle, setInputCalle] = useState();
    const [inputCP, setInputCP] = useState(datosPersonales?.CPEmp);
    const [estado, setEstado] = useState();
    const [municipio, setMunicipio] = useState();
    const [ciudad, setCiudad] = useState();
    const [colonia, setColonia] = useState();
    const [inputAnioResidencia, setInputAnioResidencia] = useState();
    const [inputMesesResidencia, setInputMesesResidencia] = useState();

    const [dataIngreso,] = useState([
        {title:"5,000 - 15,000", val:"15000"},
        {title:"16,000 - 30,000", val:"30000"},
        {title:"31,000 - 50,000", val:"50000"},
        {title:"51,000 - 75,000", val:"75000"},
        {title:"76,000 - 100,000", val:"100000"},
        {title:"> 100,000", val:"100000"},
    ]);

    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            ingreso: "",
        }
    })

    const valIngreso = {
        required: 'Campo obligatorio',
    };
    
    const [ingreso, setIngreso] = useState(false);
    const seleccionaringreso = (e) => {
        setIngreso(e.target.value);
    }

     // consulta get Telmex
     const handleInformacionIne = data => {
        
        console.log("data form",data);

        //setDatos({
        //    "numero": data.numero,
        //    "contrasena": data.contrasena
        //})

        setInfoIngmensualStorage({
            "Ingmensual": data.ingreso,
        })

        //calificacionClaroScore no fue buena y le aparesca la pantalla "si cuenta con tarjeta bancaria, PreguntaSinTelmex(componente)"
        if(!lineaTelmex){
            history.push(`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-sin-telefono-telmex`);
        }else{
            history.push(`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-creacion-nip`);
        }
    }

    

    //useEffect(() => {
    //    if (returnForm === true) {
    //        setInfoPersonalStorage(datos);
    //        SetReturnForm(false);
    //        nextPage(2);
    //    }
    //}, [returnForm])


    // llenado de campos con cp
    useEffect(() => {
        if (inputCP) {
            if (inputCP.length === 5) {
                getShipping({ codigoPostal: inputCP })
                    .then(setShupping)
            }
            else if (inputCP.length < 5 || inputCP.length === 0) {
                setEstado('');
                setMunicipio('');
                setCiudad('');
                setColonia([]);
            }
        }
    }, [inputCP])

    useEffect(() => {
        if (shipping) {
            setEstado(shipping.estado);
            setMunicipio(shipping.municipio);
            setCiudad(shipping.ciudad);

            if (shipping?.code === 200) {
                clearErrors('estado');
                clearErrors("ciudad");
                clearErrors("colonia");
                clearErrors("municipio");
            }

            if (shipping.colonias) {
                if (shipping.colonias.length === 0) {
                    setColonia([]);
                }
                else if (shipping.colonias.length >= 1) {
                    setColonia(shipping.colonias);
                }
            }

            if (shipping?.code === 404) {
                setShowModalErr(true);
                setErrorCode(shipping?.code);
                setSectionActive('cp');
                setMessageResponse(shipping?.error);
            }
        }
    }, [shipping])



    return (
        <>
            <div className="modalCredito full">
                <div className="contentModal">
                {
                    EXTERNO ? null : <HeaderMobileCredito title={"Solicitud de crédito ClaroShop"} type="backFull" />
                }
                    <main className='nuevoCredito ultimosPasos'>
                        <ProgressBar progress={60} />
                        
                        <h1 className='bold fontsize18 texto'>¿Cuál es ingreso mensual?</h1>

                        <div className='contenidoSolicitarTarjeta fullBottom'>
                            <form onSubmit={handleSubmit(handleInformacionIne)}>
                                
                                <div className="viviendaBox">
                                    <div className="subCampo">
                                        <ul className="ulOcupacion" onChange={seleccionaringreso}>
                                            {dataIngreso.map((item,index)=>
                                                <li key={index}>
                                                    <label name={item.val} htmlFor={item.val}> {item.title} </label>
                                                    <input className="radio" id={item.val} type="radio" value={item.val} name="ingreso"  ref={register(valIngreso)} />
                                                </li>
                                            )}
                                        </ul>
                                        <div className="secEmpleo">
                                            <div className="campo boxSexo">
                                                {ingreso === false && errors.ingreso && errors.ingreso.message
                                                    ? <div className="error">Campo obligatorio</div>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                
                            </form>
                        </div>
                    </main>
                </div>
            </div>
            <div className="boxBtnSolicitar top">
                <button className="btnSolicitar" onClick={handleSubmit(handleInformacionIne)}> Continuar</button>
            </div>
        </>
    )
}